import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import TextShadowColorListItem from './TextShadowColorListItem';
import TextShadowBlurListItem from './TextShadowBlurListItem';
import TextShadowOpacityListItem from './TextShadowOpacityListItem';
import TextShadowDistanceListItem from './TextShadowDistanceListItem';
import TextShadowAngleListItem from './TextShadowAngleListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';

const TextShadowListItem = (props) => {
    const { shadowSettingsEnabled, updateTextElement, index } = props;

    const onShadowEnabledChange = (value) => updateTextElement(index, { 
        shadowSettings: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={shadowSettingsEnabled}
            text='Shadow'
            onChange={onShadowEnabledChange}
        >
            <List dense disablePadding>
                <TextShadowColorListItem index={index} />
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <TextShadowBlurListItem index={index} />
                        },
                        {
                            width: 6,
                            component: <TextShadowOpacityListItem index={index} />
                        }
                    ]}
                />
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <TextShadowDistanceListItem index={index} />
                        },
                        {
                            width: 6,
                            component: <TextShadowAngleListItem index={index} />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const shadowSettingsEnabled = element && element.shadowSettings ? element.shadowSettings.enabled : false;
    return { shadowSettingsEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextShadowListItem);
